var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPldLocationPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.842 4.568a8.708 8.708 0 0112.315 12.314l-1.188 1.174c-.875.859-2.01 1.963-3.406 3.313a2.25 2.25 0 01-3.128-.001l-3.49-3.396c-.44-.43-.807-.794-1.103-1.09a8.71 8.71 0 010-12.314zM17.095 5.63A7.207 7.207 0 106.903 15.822l1.487 1.467a743.503 743.503 0 003.088 3 .75.75 0 001.043 0l3.394-3.3c.47-.46.864-.849 1.18-1.167a7.207 7.207 0 000-10.192zM12 7.5a3.5 3.5 0 11-.002 7.001A3.5 3.5 0 0112 7.5zM12 9a2 2 0 10-.001 4 2 2 0 000-4z",
    fill: "#333230"
  })));
}
export default SvgPldLocationPin;